import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["row"]

  selectRow(event) {
    this.rowTargets.forEach(element => {
      element.classList.remove("is-active")
    })

    const selectedRow = this.rowTargets.find(element =>
      element.dataset.recipientId === event.target.dataset.recipientId
    )

    if (selectedRow) {
      selectedRow.classList.add("is-active")
    }
  }
}
